define( function() {

"use strict";

return /^--/;

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/css/var/rcustomProp.js
// module id = 382
// module chunks = 1